import Form from "react-bootstrap/Form";

type CheckboxProps = {
  label: string;
  handleCheck: (event) => void;
  name?: string;
  isInvalid?: boolean;
  isValid?: boolean;
  defaultChecked?: boolean;
  children?: React.ReactNode;
};

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({
  label,
  handleCheck,
  name,
  isInvalid,
  isValid,
  defaultChecked,
  children,
}) => {
  return (
    <div>
      <Form.Check
        type="checkbox"
        label={label}
        isInvalid={false}
        isValid={false}
        defaultChecked={defaultChecked}
        name={name}
        onClick={(e) =>
          handleCheck(e)
        }
      />
    </div>
  );
};
